import type { MailboxInfo } from "owa-client-types";
import { action } from "satcheljs";
import { updateSelectedCalendarsInStore, addSelectedCalendarInStore } from "./internalActions";
import { updateSelectedCalendarsState } from "../services/updateSelectedCalendarsState";
import { getSelectedCalendarsForUser } from "../selectors/getSelectedCalendarsForUser";

export const updateSelectedCalendars = (calendarIds: string[], mailboxInfo: MailboxInfo): void => {
    updateSelectedCalendarsInStore(calendarIds, mailboxInfo);
    selectedCalendarsUpdated(calendarIds, mailboxInfo);
    updateSelectedCalendarsState(calendarIds, mailboxInfo);
};

export const addSelectedCalendar = (calendarId: string, mailboxInfo: MailboxInfo): void => {
    addSelectedCalendarInStore(calendarId, mailboxInfo);
    const updatedCalendars = getSelectedCalendarsForUser(mailboxInfo);
    selectedCalendarsUpdated(updatedCalendars, mailboxInfo);
    updateSelectedCalendarsState(updatedCalendars, mailboxInfo);
};

export interface SELECTED_CALENDARS_UPDATEDActionMessage {
    calendarIds: string[];
    mailboxInfo: MailboxInfo;
}
export const selectedCalendarsUpdated: (calendarIds: string[], mailboxInfo: MailboxInfo) => SELECTED_CALENDARS_UPDATEDActionMessage = action("SELECTED_CALENDARS_UPDATED", (calendarIds: string[], mailboxInfo: MailboxInfo): SELECTED_CALENDARS_UPDATEDActionMessage => ({
    calendarIds,
    mailboxInfo,
}));

export interface REFRESH_IMMUTABLE_SELECTED_CALENDARSActionMessage {
    mailboxInfo: MailboxInfo;
}
export const refreshImmutableSelectedCalendars: (mailboxInfo: MailboxInfo) => REFRESH_IMMUTABLE_SELECTED_CALENDARSActionMessage = action("REFRESH_IMMUTABLE_SELECTED_CALENDARS", (mailboxInfo: MailboxInfo): REFRESH_IMMUTABLE_SELECTED_CALENDARSActionMessage => ({
    mailboxInfo,
}));
